// One row of the "unapproved student reports" summary page — mirrors the backend
// UnapprovedReportSummaryResource. NOTE: this API serializes with PropertyNamingPolicy = null,
// i.e. PascalCase over the wire (same as CodeObject reading `.Id`/`.Name`).
export default class UnapprovedReportSummary {
  reportId: number

  institutionId: number

  institutionName: string

  institutionHeadName: string

  uploadedAt: Date

  statusId: number

  rowCount: number

  errorCodes: number[]

  canApprove: boolean

  blockingReasons: string[]

  constructor(data: any) {
    this.reportId = data.ReportId
    this.institutionId = data.InstitutionId
    this.institutionName = data.InstitutionName ?? ''
    this.institutionHeadName = data.InstitutionHeadName ?? ''
    this.uploadedAt = data.UploadedAt ? new Date(data.UploadedAt) : new Date()
    this.statusId = data.StatusId
    this.rowCount = data.RowCount ?? 0
    this.errorCodes = data.ErrorCodes ?? []
    this.canApprove = data.CanApprove ?? false
    this.blockingReasons = data.BlockingReasons ?? []
  }
}
